(function () {
  const intervalTime = 500;
  const maxTime = 20000;
  const quickModalRatingSummarySelector =
    '[data-quick-product-modal] [data-bv-show="rating_summary"]';

  // Reusable function to add aria attributes to element
  function makeButton(element, label) {
    const patchedAttr = "data-a11y-patched";

    if (!element) return false;
    if (element.hasAttribute(patchedAttr)) return true;

    element.setAttribute("role", "button");
    element.setAttribute("aria-label", label);

    if (!element.hasAttribute("tabindex")) {
      element.setAttribute("tabindex", "0");
    }

    element.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        element.click();
      }
    });

    element.setAttribute(patchedAttr, "true");

    return true;
  }

  // Fix BV filter button
  function patchBazaarvoiceFiltersButton() {
    const element = document.querySelector(
      '[data-bv-show="reviews"] .bv-rnr__sc-1kd7i6j-0.gRnrQW',
    );

    return makeButton(element, "Filters");
  }

  // Fix BV sort button
  function patchBazaarvoiceSortButton() {
    const element = document.querySelector(
      '[data-bv-show="reviews"] .bv-rnr__sc-1kd7i6j-0.jfLCGO',
    );

    return makeButton(element, "Sort reviews");
  }

  // BV renders this rating summary as interactive markup inside quick-add modals
  function patchQuickProductModalRatingSummary() {
    document
      .querySelectorAll(quickModalRatingSummarySelector)
      .forEach(function (summary) {
        if (summary.style.getPropertyValue("cursor") !== "default") {
          summary.style.setProperty("cursor", "default", "important");
        }

        if (summary.style.getPropertyValue("pointer-events") !== "none") {
          summary.style.setProperty("pointer-events", "none", "important");
        }

        summary
          .querySelectorAll("button, a[href], [tabindex]")
          .forEach(function (element) {
            if (element.getAttribute("tabindex") !== "-1") {
              element.setAttribute("tabindex", "-1");
            }

            element.removeAttribute("href");
            element.removeAttribute("aria-haspopup");
            element.removeAttribute("aria-expanded");
            element.removeAttribute("aria-controls");

            if ("disabled" in element && !element.disabled) {
              element.disabled = true;
            }
          });
      });
  }

  function watchQuickProductModalRatingSummary() {
    const modal = document.querySelector("[data-quick-product-modal]");

    if (!modal) {
      return;
    }

    patchQuickProductModalRatingSummary();

    if (!window.MutationObserver) {
      return;
    }

    new MutationObserver(patchQuickProductModalRatingSummary).observe(modal, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  function runWhenReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }

    callback();
  }

  function startTimedPatches() {
    let patches = [patchBazaarvoiceFiltersButton, patchBazaarvoiceSortButton];
    const startTime = Date.now();

    function runPatches() {
      patches = patches.filter(function (patch) {
        return !patch();
      });
    }

    runPatches();

    if (patches.length === 0) {
      return;
    }

    const interval = setInterval(function () {
      runPatches();

      if (patches.length === 0 || Date.now() - startTime >= maxTime) {
        clearInterval(interval);
      }
    }, intervalTime);
  }

  startTimedPatches();
  runWhenReady(watchQuickProductModalRatingSummary);
  runWhenReady(() => {
    const $form = document.querySelector('#account-login, #RegisterForm');
    $form && document.querySelector('.form-status__message--error')?.focus();
  });
})();
